<script lang="ts">
  import { scrollY } from '../../app-state.svelte';

  // Track which chapter/section is in view (active nav highlight).
  // Compute from scrollY + a periodic re-read of offsets (cheap enough at scroll rate).
  const sectionIds = ['top', 'reg-1', 'reg-2', 'reg-3', 'reg-4', 'currents'];
  let activeSection = $state('top');

  function recompute() {
    const mid = window.scrollY + window.innerHeight * 0.32;
    let cur = 'top';
    for (const id of sectionIds) {
      const el = document.getElementById(id);
      if (!el) continue;
      const top = el.getBoundingClientRect().top + window.scrollY;
      if (top <= mid) cur = id;
    }
    activeSection = cur;
  }

  // Recompute on scroll changes (via reactive dep on scrollY).
  $effect(() => {
    void scrollY();
    if (typeof document !== 'undefined') recompute();
  });
</script>

<header class="rail" class:solid={scrollY() > 60}>
  <div
    class="rail__mark"
    class:dim={activeSection !== 'top'}
    role="button"
    tabindex="0"
    onclick={() => document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' })}
    onkeydown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
      }
    }}>
    Гримуар · <b>Opus&nbsp;Magnum</b>
  </div>
  <nav class="rail__nav">
    <button
      data-st="I"
      class:active={activeSection === 'reg-1'}
      onclick={() => document.getElementById('reg-1')?.scrollIntoView({ behavior: 'smooth' })}>
      <b>I</b><i>Nigredo</i>
    </button>
    <button
      data-st="II"
      class:active={activeSection === 'reg-2'}
      onclick={() => document.getElementById('reg-2')?.scrollIntoView({ behavior: 'smooth' })}>
      <b>II</b><i>Albedo</i>
    </button>
    <button
      data-st="III"
      class:active={activeSection === 'reg-3'}
      onclick={() => document.getElementById('reg-3')?.scrollIntoView({ behavior: 'smooth' })}>
      <b>III</b><i>Citrinitas</i>
    </button>
    <button
      data-st="IV"
      class:active={activeSection === 'reg-4'}
      onclick={() => document.getElementById('reg-4')?.scrollIntoView({ behavior: 'smooth' })}>
      <b>IV</b><i>Rubedo</i>
    </button>
    <button
      class:active={activeSection === 'currents'}
      onclick={() => document.getElementById('currents')?.scrollIntoView({ behavior: 'smooth' })}>
      <b>☿</b><i>Струны</i>
    </button>
  </nav>
</header>

<style>
  /* Active section indicator: underline-ish dot beneath the button. */
  .rail__nav button.active {
    color: var(--ink);
  }
  .rail__nav button.active::after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--mercury);
    opacity: 0.7;
  }
  .rail__nav button {
    position: relative;
  }
  .rail__mark.dim {
    opacity: 0.6;
  }
</style>
